import { CardActionArea } from '@mui/material';
import customTwMerge from 'utils/twMerge';
import { CCard, CCardContent, CCardMedia } from 'components/atoms';
import { ActionCardProps } from 'types/molecules';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightSvg } from 'assets/svg/arrow-right.svg';

export default function ActionCard({
  title,
  description,
  img,
  imgSrc,
  containerClassName,
  contentClassName,
  contentTitleClassName,
  contentDescriptionClassName,
  imgContainerClassName,
  imgClassName,
  className,
  isBorderX,
  isBorderPrimary,
  isBorderSecondary,
  onClick,
  isDefault,
  type = 'horizontal',
  showIcon = true,
  isSentryMask,
}: ActionCardProps) {
  const { t } = useTranslation('common');

  const classes = {
    horizontal: {
      containerClassName: customTwMerge('', containerClassName),
      className: customTwMerge('flex h-full justify-start gap-4 p-2', className),
      imgContainerClassName: customTwMerge('aspect-square w-24', imgContainerClassName),
      imgClassName: customTwMerge('', imgClassName),
      contentClassName: customTwMerge('', contentClassName),
      contentTitleClassName: customTwMerge('', contentTitleClassName),
      contentDescriptionClassName: customTwMerge('', contentDescriptionClassName),
    },
    vertical: {
      containerClassName: customTwMerge('', containerClassName),
      className: customTwMerge('flex flex-col gap-4 p-2 items-start h-full', className),
      imgContainerClassName: customTwMerge('', imgContainerClassName),
      imgClassName: customTwMerge('', imgClassName),
      contentClassName: customTwMerge('grow-0', contentClassName),
      contentTitleClassName: customTwMerge('text-neutral-700 text-label18', contentTitleClassName),
      contentDescriptionClassName: customTwMerge(
        'text-neutral-600 text-body14 line-clamp-2',
        contentDescriptionClassName
      ),
    },
  };

  return (
    <CCard
      isBorderX={isBorderX}
      isBorderPrimary={isBorderPrimary}
      isBorderSecondary={isBorderSecondary}
      className={classes[type].containerClassName}
    >
      <CardActionArea className={classes[type].className} onClick={onClick}>
        {imgSrc ? (
          <CCardMedia
            imgSrc={imgSrc}
            alt={title}
            className={classes[type].imgClassName}
            containerClassName={classes[type].imgContainerClassName}
          />
        ) : img ? (
          <CCardMedia
            className={classes[type].imgClassName}
            containerClassName={classes[type].imgContainerClassName}
          >
            {img}
          </CCardMedia>
        ) : null}

        <CCardContent
          title={title}
          description={description}
          className={classes[type].contentClassName}
          titleClassName={classes[type].contentTitleClassName}
          descriptionClassName={classes[type].contentDescriptionClassName}
          isSentryMask={isSentryMask}
        />

        {type === 'horizontal' && showIcon ? (
          <ArrowRightSvg className="shrink-0" />
        ) : type === 'vertical' && showIcon ? (
          <div className="ml-auto flex items-center gap-2 text-label14 text-secondary-800">
            <span>{t('more')}</span>

            <ArrowRightSvg className="shrink-0" />
          </div>
        ) : null}

        {isDefault && (
          <span className="absolute bottom-0 right-0 bg-secondary-800 px-3 py-1 text-body12 text-neutral-0">
            {t('default')}
          </span>
        )}
      </CardActionArea>
    </CCard>
  );
}

